import { RouteLoadingShell } from "@/components/portal/route-loading-shell";

export default function SharedChatLoading() {
  return <RouteLoadingShell variant="shared-chat" />;
}
